import { Box, ListItemButton } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Link } from 'react-router-dom';

export const MenuWrapper = styled(Box)(
  ({ theme }) => `
  .MuiList-root {
    padding: ${theme.spacing(1)};
 
    & > .MuiList-root {
      padding: 0 ${theme.spacing(0)} ${theme.spacing(1)};
    }
    background: white;
  }
 
  .MuiListSubheader-root {
    text-transform: uppercase;
    font-weight: bold;
    font-size: ${theme.typography.pxToRem(12)};
    color: ${theme.colors.alpha.trueWhite[50]};
    padding: ${theme.spacing(0, 2.5)};
    line-height: 1.4;
  }`
);

export const SidebarMenuWrapper = styled('ul')(() => `
  margin-top: 20px;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
  list-style: none;
`);

export const SidebarSectionTitle = styled('div')(() => `
  color: #EB0A1E;
  font-size: 14px;
  font-weight: 700;
`);

export const SidebarSection = styled('ul')(() => `
  padding: 0;
  margin-left: 0;
  margin-top: 12px;
  display: flex;
  flex-direction: column;
  gap: 9px;
  list-style: none;
`);

export const SearchDocsWrapper = styled('div')(() => `
  display: flex;
  align-items: stretch;
  border: 1px solid #E0E0E0;
  border-radius: 6px;
  overflow: hidden;
  height: 36px;
`);

export const SearchDocsRelative = styled('div')(() => `
  position: relative;
`);

export const SearchDocsInput = styled('input')(() => `
  flex: 1;
  border: none;
  outline: none;
  padding: 0 12px;
  font-size: 14px;
  color: #424242;
  background: white;
  min-width: 0;
  
  &::placeholder {
    color: #9E9E9E;
  }
`);

export const SearchDocsBtn = styled('button')(() => `
  background: #EB0A1E;
  border: none;
  width: 36px;
  flex-shrink: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
`);

export const ExploreTopicsBtn = styled(Link)(() => `
  display: flex;
  align-items: center;
  gap: 8px;
  background: transparent;
  color: #424242;
  border: none;
  border-radius: 6px;
  padding: 8px 0;
  padding-left: 10px;
  font-size: 14px;
  font-weight: 400;
  text-decoration: none;
  cursor: pointer;

  &.active {
    background: #EB0A1E;
    color: white;
    padding: 8px 16px;
  }
`);

export const ExploreTopicsIcon = styled('img')(() => `
  width: 16px;
  height: 16px;

  &.active {
    filter: brightness(0) invert(1);
  }
`);

export const BrowseDocsIcon = styled('img')(() => `
  width: 16px;
  height: 16px;
`);

export const SidebarItem = styled('li')(() => `
  padding: 4.5px 0;
  padding-left: 10px;
  border-radius: 8px;
  display: inline-block;

  &.sidebar-selected {
    background: red;
  }
  
  &.sidebar-selected a{
    color: white;
  }
  
  &.sidebar-selected img{
    filter: brightness(0) invert(1);
  }
`);

export const SidebarItemLink = styled(Link)(() => `
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 112.2%;
  display: flex;
  align-items: center;
  gap: 10px;
  text-decoration: none;
  color: #424242;
`);

export const SidebarDropdown = styled('span')(() => `
  display: inline-flex;
  align-items: center;
`);

export const SidebarDropdownIcon = styled('img')(() => `
  transition: transform 0.2s;
  &.dropdown-open {
    transform: rotate(180deg);
  }
`);

export const SyncDocsButton = styled('span')(() => `
  margin-left: auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #757575;
  padding: 2px;
  border-radius: 4px;

  &:hover {
    color: #EB0A1E;
  }

  &.syncing {
    color: #EB0A1E;
    cursor: default;
  }

  & svg {
    width: 16px;
    height: 16px;
  }

  &.syncing svg {
    animation: kb-sync-spin 1s linear infinite;
  }

  @keyframes kb-sync-spin {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
  }
`);

export const LastSyncedText = styled('div')(() => `
  font-size: 11px;
  line-height: 1.3;
  color: #9e9e9e;
  padding: 2px 8px 6px 26px;
`);

export const ListItemDocs = styled(ListItemButton)(() => `
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 112.2%;
  color: #424242;
  padding: 4px 8px;
  border-radius: 6px;

  &.sidebar-selected {
    background: #EB0A1E;
    color: white;

    .MuiListItemText-primary {
      color: white;
    }

    img {
      filter: brightness(0) invert(1);
    }
  }
`);

export const DocsBtn = styled('button')(() => `
  background: none;
  border: none;
  cursor: pointer;
  text-align: left;
  width: 100%;
  padding: 4px 16px;
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 112.2%;
  color: #424242;

  &:hover {
    background: #f5f5f5;
    border-radius: 4px;
  }

  &.sidebar-selected {
    background: #EB0A1E;
    color: white;
    border-radius: 4px;
  }
`);
